"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityDto = instanceOfFacilityDto;
exports.FacilityDtoFromJSON = FacilityDtoFromJSON;
exports.FacilityDtoFromJSONTyped = FacilityDtoFromJSONTyped;
exports.FacilityDtoToJSON = FacilityDtoToJSON;
exports.FacilityDtoToJSONTyped = FacilityDtoToJSONTyped;
const AddressDto_1 = require("./AddressDto");
/**
 * Check if a given object implements the FacilityDto interface.
 */
function instanceOfFacilityDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    if (!('photoUrl' in value) || value['photoUrl'] === undefined)
        return false;
    if (!('active' in value) || value['active'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
function FacilityDtoFromJSON(json) {
    return FacilityDtoFromJSONTyped(json, false);
}
function FacilityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'address': (0, AddressDto_1.AddressDtoFromJSON)(json['address']),
        'description': json['description'] == null ? undefined : json['description'],
        'website': json['website'] == null ? undefined : json['website'],
        'photoUrl': json['photoUrl'],
        'active': json['active'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function FacilityDtoToJSON(json) {
    return FacilityDtoToJSONTyped(json, false);
}
function FacilityDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'address': (0, AddressDto_1.AddressDtoToJSON)(value['address']),
        'description': value['description'],
        'website': value['website'],
        'photoUrl': value['photoUrl'],
        'active': value['active'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}
//# sourceMappingURL=FacilityDto.js.map